class CartPurchaseLimits {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.checkAllLimits();
  }

  bindEvents() {
    // Controlla quando cambia la quantità
    document.addEventListener('input', (e) => {
      if (e.target.matches('.cart__quantity-field, [data-quantity-input]')) {
        this.checkQuantityLimit(e.target);
      }
    });

    // Controlla i pulsanti +/-
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cart__quantity-plus, .cart__quantity-minus')) {
        setTimeout(() => {
          const input = e.target.closest('.cart__quantity').querySelector('input');
          if (input) {
            this.checkQuantityLimit(input);
          }
        }, 100);
      }
    });

    // Ascolta gli eventi di aggiornamento del carrello
    document.addEventListener('cart:updated', () => {
      this.checkAllLimits();
    });
  }

  checkAllLimits() {
    // Controlla solo gli input che hanno effettivamente un limite
    const quantityInputs = document.querySelectorAll('.cart__quantity-field[data-purchase-limit]');
    quantityInputs.forEach(input => {
      const limit = input.dataset.purchaseLimit ? parseInt(input.dataset.purchaseLimit) : null;
      const otherQty = input.dataset.otherQty ? parseInt(input.dataset.otherQty) : 0;
      
      if (limit) {
        // Il limite effettivo è il limite totale meno le altre istanze della stessa variante
        const effectiveLimit = Math.max(1, limit - otherQty);
        this.applyLimit(input, effectiveLimit);
      }
    });
  }

  checkQuantityLimit(input) {
    // Controlla SOLO se l'input ha effettivamente un limite
    if (!input.dataset.purchaseLimit) {
      return; // Nessun limite, esci
    }
    
    const limit = input.dataset.purchaseLimit ? parseInt(input.dataset.purchaseLimit) : null;
    const otherQty = input.dataset.otherQty ? parseInt(input.dataset.otherQty) : 0;
    
    if (limit) {
      const currentValue = parseInt(input.value) || 0;
      const effectiveLimit = Math.max(1, limit - otherQty);
      
      if (currentValue > effectiveLimit) {
        input.value = effectiveLimit;
        this.showLimitWarning(input, effectiveLimit, limit, otherQty);
        
        // Aggiorna il carrello con il valore limitato
        this.updateCart(input.dataset.id, effectiveLimit);
      }
      
      // Disabilita il pulsante + se siamo al limite effettivo
      const plusButton = input.parentElement.querySelector('.cart__quantity-plus');
      if (plusButton) {
        plusButton.disabled = (currentValue >= effectiveLimit);
      }
      
      // Abilita il pulsante - se non siamo a 0
      const minusButton = input.parentElement.querySelector('.cart__quantity-minus');
      if (minusButton) {
        minusButton.disabled = (currentValue <= 1);
      }
    }
  }

  applyLimit(input, limit) {
    const currentValue = parseInt(input.value) || 0;
    
    // Imposta il max attribute
    input.max = limit;
    
    // Disabilita il pulsante + se siamo al limite
    const plusButton = input.parentElement.querySelector('.cart__quantity-plus');
    if (plusButton) {
      plusButton.disabled = (currentValue >= limit);
      
      // Aggiungi tooltip
      if (currentValue >= limit) {
        let message;
      if (otherQty && otherQty > 0) {
        message = this.translateMessage('maxLimitMultiple', { 
          limit: totalLimit || effectiveLimit, 
          other: otherQty,
          remaining: effectiveLimit 
        });
      } else {
        message = this.translateMessage('maxLimit', { limit: effectiveLimit });
      }
        plusButton.title = message;
      }
    }
  }

  translateMessage(key, replacements = {}) {
    let message = window.purchaseLimitTranslations?.[key] || key;
    
    // Sostituisci i placeholder
    Object.keys(replacements).forEach(placeholder => {
      const regex = new RegExp(`{{\\s*${placeholder}\\s*}}`, 'g');
      message = message.replace(regex, replacements[placeholder]);
    });
    
    return message;
  }

  showLimitWarning(input, effectiveLimit, totalLimit, otherQty) {
    // Rimuovi warning esistenti
    const existingWarning = input.closest('.cart__item').querySelector('.cart__limit-flash-warning');
    if (existingWarning) {
      existingWarning.remove();
    }

    // Crea e mostra un warning temporaneo
    const warning = document.createElement('div');
    warning.className = 'cart__limit-flash-warning';
    warning.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #dc3545; color: white; padding: 8px 12px; border-radius: 4px; z-index: 100; white-space: nowrap;';
    const message = this.translateMessage('maxLimit', { limit });
    warning.textContent = message;
    
    const itemContainer = input.closest('.cart__item');
    if (itemContainer) {
      itemContainer.style.position = 'relative';
      itemContainer.appendChild(warning);
      
      // Rimuovi dopo 3 secondi
      setTimeout(() => {
        warning.remove();
      }, 3000);
    }
  }

  async updateCart(lineKey, quantity) {
    try {
      const formData = new FormData();
      formData.append('id', lineKey);
      formData.append('quantity', quantity);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        const cart = await response.json();
        
        // Trigger eventi di aggiornamento carrello
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart },
          bubbles: true
        }));

        // Aggiorna il totale se presente
        this.updateCartTotal(cart);
      }
    } catch (error) {
      console.error('Errore nell\'aggiornamento del carrello:', error);
    }
  }

  updateCartTotal(cart) {
    // Aggiorna il totale del carrello
    const totalElements = document.querySelectorAll('[data-cart-total]');
    totalElements.forEach(element => {
      element.textContent = this.formatMoney(cart.total_price);
    });

    // Aggiorna il contatore articoli
    const countElements = document.querySelectorAll('[data-cart-count]');
    countElements.forEach(element => {
      element.textContent = cart.item_count;
    });
  }

  formatMoney(cents) {
    const euros = (cents / 100).toFixed(2);
    return `€${euros.replace('.', ',')}`;
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cartPurchaseLimits = new CartPurchaseLimits();
  });
} else {
  window.cartPurchaseLimits = new CartPurchaseLimits();
}

// Reinizializza quando il carrello viene aggiornato dinamicamente
document.addEventListener('shopify:section:load', () => {
  window.cartPurchaseLimits = new CartPurchaseLimits();
});